import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill } from "@/components/Bits";

const STATUS_COLORS = { present: "bg-sage-deep text-white", absent: "bg-red-500 text-white", sick: "bg-mustard text-ink", leave: "bg-lavender-deep text-white" };

export default function ParentAttendance() {
  const [att, setAtt] = useState([]);
  useEffect(() => { api.get("/attendance").then(r => setAtt(r.data)); }, []);

  const stats = att.reduce((m, a) => { m[a.status] = (m[a.status]||0)+1; return m; }, {});
  const pct = att.length ? Math.round((stats.present || 0) / att.length * 100) : 0;

  return (
    <div>
      <PageHeader eyebrow="Attendance" title="Your child's attendance" subtitle="Patterns, presence and gentle insights." />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <Panel><div className="text-sm text-ink-soft">Overall</div><div className="font-heading font-bold text-3xl mt-1 text-sage-deep">{pct}%</div></Panel>
        <Panel><div className="text-sm text-ink-soft">Present</div><div className="font-heading font-bold text-3xl mt-1">{stats.present || 0}</div></Panel>
        <Panel><div className="text-sm text-ink-soft">Absent</div><div className="font-heading font-bold text-3xl mt-1">{stats.absent || 0}</div></Panel>
        <Panel><div className="text-sm text-ink-soft">Sick</div><div className="font-heading font-bold text-3xl mt-1">{stats.sick || 0}</div></Panel>
      </div>

      <Panel title="Last few days">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {att.slice(0, 18).map(a => (
            <div key={a.attendance_id} className="p-3 rounded-2xl bg-paper-alt flex items-center justify-between">
              <div>
                <div className="font-semibold">{a.date}</div>
                <div className="text-xs text-ink-soft">{a.arrival_time || "—"} → {a.departure_time || "—"}</div>
              </div>
              <span className={`px-3 py-1 rounded-full text-xs font-semibold uppercase ${STATUS_COLORS[a.status] || ""}`}>{a.status}</span>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
